module.exports = __webpack_public_path__ + "static/pointImage-a92dcc4d411f8f1616a6863cc8057dd3.png";